export function groupWhatsAppReactions(reactions, labels) {
  const groups = new Map();
  for (const reaction of reactions) {
    if (!reaction.emoji) continue;
    const group = groups.get(reaction.emoji) || {
      emoji: reaction.emoji,
      names: [],
      mine: false,
    };
    group.names.push(reaction.fromMe ? labels.you : reaction.name || labels.contact);
    group.mine ||= reaction.fromMe === true;
    groups.set(reaction.emoji, group);
  }
  return [...groups.values()];
}
